import React from 'react';
import { useParams } from 'react-router-dom';
import { getSowDataPath } from 'core/routing/paths';
import ContractFormView from 'pages/WirelineEngagements/shared/ContractForm/ContractFormView';

const SowDataContractRequestView = () => {
  const { wirelineEngagementId, customerId } = useParams();

  const backRoutePath = getSowDataPath(wirelineEngagementId, customerId);

  return (
    <ContractFormView
      backRoutePath={backRoutePath}
    />
  );
};

export default SowDataContractRequestView;
